import styled from 'styled-components';
import * as system from 'styled-system';

export type BoxProps = system.GridProps &
  system.PositionProps &
  system.SpaceProps &
  system.BackgroundProps &
  system.TypographyProps &
  system.ColorProps &
  system.BorderProps &
  system.ShadowProps &
  system.LayoutProps &
  system.FlexboxProps;

export const box = system.compose(
  system.grid,
  system.position,
  system.space,
  system.background,
  system.typography,
  system.color,
  system.border,
  system.shadow,
  system.layout,
  system.flexbox
);

const Box = styled('div')<BoxProps>(
  {
    boxSizing: 'border-box',
  },
  box
);

const FormBox = styled('form')<BoxProps & { isTablet: boolean }>`
  box-sizing: border-box;
  max-width: ${(p) => (p.isTablet ? '100%' : '930px')};
  width: 100%;
  padding: ${(p) => (p.isTablet ? '30px 15px' : '50px 30px')};
  border-radius: 15px;
  background-color: ${(p) => p.theme.colors.light};
  ${box}
`;

export { Box, FormBox };
